var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionWithGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1167_1334)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.451 13.073.457-1.2-1.067-2.8a.948.948 0 0 1 .367-1.129l2.508-1.637.783-2.892a.947.947 0 0 1 .961-.698l2.992.152L12.785.986a.947.947 0 0 1 1.189 0l2.332 1.883 2.992-.15a.947.947 0 0 1 .961.699l.783 2.892 2.508 1.637a.946.946 0 0 1 .367 1.13l-1.066 2.8 1.067 2.799a.948.948 0 0 1-.368 1.13l-2.508 1.633-.787 2.893a.946.946 0 0 1-.961.699l-2.992-.149-2.332 1.879",
    stroke: "url(#paint0_linear_1167_1334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.02 20.185 1.69 2.662",
    stroke: "url(#paint1_linear_1167_1334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.365 8.325 6.423 10.119",
    stroke: "url(#paint2_linear_1167_1334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.45 17.91 2.373 22.316l-1.015-1.598 9.345-11.86 5.747 9.053Z",
    stroke: "url(#paint3_linear_1167_1334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.414 21.362.894 1.374a2.083 2.083 0 0 0 2.965.626 2.302 2.302 0 0 0 .6-3.102l-.167-.24",
    stroke: "url(#paint4_linear_1167_1334)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1167_1334",
    x1: 3.304,
    y1: -7.133,
    x2: 25.135,
    y2: -6.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6836A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA05D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1167_1334",
    x1: 1.062,
    y1: 19.227,
    x2: 2.804,
    y2: 19.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6836A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA05D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1167_1334",
    x1: 10.524,
    y1: 4.685,
    x2: 17.143,
    y2: 4.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6836A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA05D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1167_1334",
    x1: 1.732,
    y1: 4.016,
    x2: 17.265,
    y2: 4.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6836A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA05D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1167_1334",
    x1: 5.533,
    y1: 18.683,
    x2: 10.488,
    y2: 18.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6836A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEA05D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1167_1334"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .01)",
    d: "M0 0h25v24.49H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionWithGradient);
export default __webpack_public_path__ + "static/media/actionWithGradient.630290b579f095ce70a104792d791157.svg";
export { ForwardRef as ReactComponent };